import { getVoucherConfig } from '#src/services/vouchersApiService'
import { useVoucherConfigStore } from '#src/stores/voucherConfig/voucherConfigStore'

export const useVoucherConfig = () => {
  const voucherConfigStore = useVoucherConfigStore()

  const initVoucherConfig = async (tenantId: string) => {
    const res = await getVoucherConfig(tenantId)

    if (res?.data) {
      voucherConfigStore.setVoucherConfig(res.data)
    }
  }

  return {
    initVoucherConfig
  }
}
